import React, { createContext, useContext, useEffect, useRef } from "react";

import dxDataGrid from "devextreme/ui/data_grid";

import { CONST_LISTORIGIN_DICTIONARY } from "@app/state/constants";
import { PdfContextType, TListOriginName } from "@app/types/insider";

import { destroySession, pdfEngine } from "../reports/pdf_engine";

/* -------------------------------------------------------------------------- */
//TODO: #42 estimate the size of the data and if is too big then notify the to export to excel...

const PdfContext = createContext<PdfContextType>({});

export function GatherPdfData(props) {
  useEffect(() => {
    return () => {
      destroySession();
    };
  }, []);

  const pdfData = useRef<dxDataGrid>();
  const tsGridRef = useRef<dxDataGrid>();
  const lstContactsRef = useRef<dxDataGrid>();
  const anyListGridRef = useRef<dxDataGrid>();
  const detailRef = useRef<dxDataGrid[]>([]);
  const spvListRef = useRef<dxDataGrid>();
  //other data..//
  async function openPdf(pdfRootObject) {
    const refs = Object.assign(
      {},
      { pdfData: pdfData.current },
      { tsGridRef: tsGridRef?.current?.instance },
      { detailRef: detailRef },
      { lstContactsRef: lstContactsRef?.current?.instance },
      { anyListGridRef: anyListGridRef?.current?.instance },
      { spvListRef: spvListRef?.current?.instance }
    );
    await pdfEngine(pdfRootObject, refs);
    // TODO: #54 on success log to access log //
  }
  function friendlyName(listOrigin: TListOriginName) {
    switch (CONST_LISTORIGIN_DICTIONARY?.[listOrigin] !== undefined) {
      case true:
        return CONST_LISTORIGIN_DICTIONARY[listOrigin];
      default:
        return "Timesheet.pdf";
    }
  }
  //
  return (
    <PdfContext.Provider
      value={{
        pdfData,
        tsGridRef,
        lstContactsRef,
        anyListGridRef,
        detailRef,
        spvListRef,
        openPdf,
        friendlyName,
      }}
      {...props}
    />
  );
}

export const usePdfContext = () => useContext(PdfContext);
